import(/* webpackMode: "eager" */ "/app/apps/web/src/app/home/page.tsx");
